<template>
  <Card style="width:100%;overflow-x: hidden;margin-top: 10px">
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <router-link :to="{ path: '/admin/user/user/index' }">
          <Button icon="ios-arrow-back" size="small" class="mr20">返回</Button>
        </router-link>
        <span class="ivu-page-header-title mr20" v-text="$route.params.id >0 ? '编辑'+this.title : '添加'+this.title"></span>
      </div>
    </div>
    <div class="myModal">
      <Form ref="artInfo"  :model='artInfo' label-position="right" :label-width="100" :rules="ruleValidate" @submit.native.prevent>

        <form-item label="用户呢称"  >
          <Input placeholder="请输入" v-model="artInfo.nickname" readonly></Input>
        </form-item>
        <form-item label="用户手机号" >
          <Input placeholder="请输入" v-model="artInfo.phone" readonly></Input>
        </form-item>
        <form-item label="用户头像" >
          <img :src="artInfo.avatar" width="100px"></img>
        </form-item>
        <form-item label="会员状态" >
          <RadioGroup v-model="artInfo.status">
            <Radio label='1' >正常</Radio>
            <Radio label='0' >禁用</Radio>
          </RadioGroup>
        </form-item>

        <form-item label="是否开通会员卡" >
          <RadioGroup v-model="artInfo.is_card">
            <Radio label='1' >已开通</Radio>
            <Radio label='0' >未开通</Radio>
          </RadioGroup>
        </form-item>
        <form-item label="会员卡到期时间" v-if="artInfo.is_card == 1">
          <Input placeholder="请输入" v-model="artInfo.expiration_time" ></Input>
        </form-item>
        <form-item label="会员卡名称" v-if="artInfo.is_card == 1">
          <Select v-model="artInfo.card_id"  >
            <Option value="0" key="0">未开通</Option>
            <Option v-for="item in card_list" :value="item.id" :key="item.id">{{ item.title }}</Option>
          </Select>
        </form-item>
      </Form>
    </div>
    <div slot="footer">
      <Button type="primary"   @click="handleOk('artInfo')">确定</Button>
    </div>
  </div>
  </Card>
</template>
<style>
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }
.ivu-form-item-label{width: 120px!important;}
.ivu-form-item-content{width: 200px !important;margin-left: 150px!important;}
  .demo-upload-list{
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }

</style>
<script>
  import { userInfo, userEdit } from '@/api/user'
  import { cardList } from '@/api/card'
  import ueditor from '@/components/ueditorFrom/index'
  export default {
    name: 'listEdit',
    components: { ueditor },
    props: ['editShow', 'id'],
    data () {
      return {

        uploadList: [], // logo
        visible: false,
        imgUrl: '',
        title: '会员编辑',
        editor: null,
        isShow: false,
        card_list: [],
        user_id: 0,
        artInfo: {
          user_id: 0,
          nickname: 0,
          phone: 0,
          status: 0,
          ctime: 0,
          is_card: 0,
          card_id: 0,
          expiration_time: 0,
        },
        delpics:[],
        ruleValidate: {
          title: [
            { required: true, message: '请输入标题', trigger: 'string' }
          ]
        }
      }
    },
    created () {

      this.artInfo.user_id = 0
      this.artInfo.nickname = ''
      this.artInfo.status = ''
      this.artInfo.ctime = ''
      this.artInfo.phone = ''
      this.artInfo.is_card = ''
      this.artInfo.card_id = ''
      this.artInfo.expiration_time = ''

      this.articleInfo()
      this.getCardList()
    },
    methods: {
      handle (status) {
        this.$emit('updateStatusModel', false)
      },
      handleOk (name) {
        let data = { 'user_id': this.artInfo.user_id,
          'status': this.artInfo.status,
          'expiration_time': this.artInfo.expiration_time,
          'card_id':this.artInfo.card_id,
          'is_card':this.artInfo.is_card,
        }
        userEdit(data).then(res => {
          let msg = '修改成功'
          if (res.code === 200) {
            this.$Message.success(msg)
            this.$router.push({ path: '/admin/user/user/index' })
          } else {
            this.$Message.error(res.msg)
          }
        }).catch(res => {
          this.$Message.error(res.msg)
        })
      },
      articleInfo () {
        if (this.$route.params.id) {
          userInfo(this.$route.params.id).then(res => {
            // console.log(res)
            this.artInfo = res.data
            this.artInfo.status =  this.artInfo.status.toString()
            this.artInfo.is_card =  this.artInfo.is_card.toString()
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      },
      getCardList  () {
        cardList().then(res => {
          this.card_list = res.data


        }).catch(res => {
          this.loading = false
          this.$Message.error(res.msg)
        })
      },


    }
  }
</script>
